import styled from '@emotion/styled';
import React from 'react';
import { theme } from '../../theme';
/*
 * Allows setting the color of the progress bar. This has been abstracted from intent/task state
 * (success, warning, error, etc.) to give the consumer more control over theming.
*/
export const ProgressBarColorVariant = {
    Blue: theme.colors.BB100,
    Green: theme.colors.GR100,
    Red: theme.colors.RE100,
    Yellow: theme.colors.YE100,
};
const Bar = styled.div `
	width: 100%;
	border-radius: 2px;
	height: 8px;
	background-color: rgba(5, 42, 128, 0.1);

	margin: ${({ idx }) => (idx === 0 ? '0 0 0 0;' : '0 0 0 4px;')};
	position: relative;
`;
const calcFillWidth = (steps, progress) => {
    if (progress < 1)
        return 0;
    if (progress >= steps)
        return '100%';
    const result = (progress / steps) * 100;
    return `${result}%`;
};
const Fill = styled.div `
	border-radius: 2px;
	width: ${({ steps, progress }) => calcFillWidth(steps, progress)};
	height: 100%;
	position: absolute;
	background-color: ${({ variant }) => variant};
	top: 0;
	left: 0;
	transition: width 200ms ease-in-out;
`;
/**
 * A flexible container which can be used to create a progress bar with multiple sections.
 */
const SectionContainer = styled.div `
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	justify-content: center;
`;
export const ProgressBar = (props) => {
    const { sections, progress, className, variant = ProgressBarColorVariant.Blue } = props;
    /**
     * A single section of the progress bar.
    */
    const ProgressBarSection = (sectionProps) => {
        const { idx } = sectionProps;
        const localProgress = progress -
            sections.slice(0, idx).reduce((steps, total) => total + steps, 0);
        return (React.createElement(Bar, { idx: idx, "data-testid": `progress-bar-section-${idx}` },
            React.createElement(Fill, { steps: sections[idx], progress: localProgress, variant: variant, "data-testid": `progress-bar-${idx}-fill` })));
    };
    return (React.createElement(SectionContainer, { className: className }, sections.map((_, idx) => (React.createElement(ProgressBarSection, { className: className, key: `progress-bar-${idx}`, idx: idx })))));
};
//# sourceMappingURL=ProgressBar.js.map